import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { ColorPrimary01, ColorPrimary02, ColorPrimary03, ColorBlack00, ColorBlack05, ColorBlack10, ColorBlack20, ColorBlack30, ColorBlack40, ColorBlack50, ColorBlack60, ColorBlack70, ColorBlack80, ColorBlack90, ColorBlack100, ColorTextHeadline, ColorTextBody, ColorTextInverted, ColorTextAlternate, ColorTextLabel, ColorInteractionButton, ColorInteractionButtonHover, ColorInteractionButtonFocus, ColorInteractionTextLink, ColorInteractionTextLinkHover, ColorInteractionTextLinkFocus, ColorInteractionIcon, ColorInteractionIconHover, ColorInteractionSelectedState, ColorInteractionFocusIndicator, ColorInteractionDeactivated, ColorFeedbackSuccess, ColorFeedbackError, ColorFeedbackInformation, ColorFeedbackWarning, ColorFeedbackRating, ColorBackgroundSuccess, ColorBackgroundError, ColorBackgroundInformation, ColorBackgroundWarning, ColorBackground01, ColorBackground02, ColorBackground03, ColorBackground04, ColorBackground05, ColorBackground06, ColorBackground07, ColorBackgroundHero, ColorBackgroundBranded, ColorBackgroundSite, ColorBorder01, ColorBorder02, ColorBorder03, ColorBorder04, LegacyTypeDisplay01, LegacyTypeDisplay02, LegacyTypeDisplay03, LegacyTypeDisplay04, LegacyTypeDisplay05, LegacyTypeBodyLead, LegacyTypeBodyText, LegacyTypeBodyCaption, LegacyTypeBodyLabel, LegacyTypeButtonLabel, LegacyTypeButtonUnderlined, LegacyTypeButtonTextLink, TypeMobileDisplay01, TypeDesktopDisplay01, TypeMobileDisplay02, TypeDesktopDisplay02, TypeMobileDisplay03, TypeDesktopDisplay03, TypeMobileDisplay04, TypeDesktopDisplay04, TypeMobileDisplay05, TypeDesktopDisplay05, TypeMobileDisplay06, TypeDesktopDisplay06, TypeMobileBodyLead, TypeDesktopBodyLead, TypeMobileBodyText, TypeDesktopBodyText, TypeMobileBodyCaption, TypeDesktopBodyCaption, TypeMobileBodyLabel, TypeDesktopBodyLabel, TypeMobileButtonLabel, TypeDesktopButtonLabel, TypeMobileButtonUnderlined, TypeDesktopButtonUnderlined, TypeMobileButtonTextLink, TypeDesktopButtonTextLink, SpacingNone, Spacing01, Spacing02, Spacing03, Spacing04, Spacing05, Spacing06, Spacing07, Spacing08, Spacing09, Spacing10, Spacing11, Spacing12, Spacing13, Spacing14, Spacing15, Spacing16, BorderRadius00, BorderRadius01, BorderRadius02, BorderRadius03, BorderRadius04, BorderRadius05, BorderRadius06, BorderRadiusCircle, BoxShadow00, BoxShadow01, BoxShadow02, BoxShadow03, BoxShadow04, BoxShadow05 } from '@moonpig/launchpad-design-tokens/moonpig';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';

var colorValue = function colorValue(color) {
  return function (_ref) {
    var theme = _ref.theme;
    return theme.colors[color];
  };
};
var spacing$1 = function spacing(value) {
  return function (_ref2) {
    var theme = _ref2.theme;
    return theme.spacing[value];
  };
};
var spacingPx = function spacingPx(value) {
  return function (_ref3) {
    var theme = _ref3.theme;
    return "".concat(spacing$1(value)({
      theme: theme
    }), "px");
  };
};

var breakpointMap = {
  xs: 0,
  sm: 400,
  md: 640,
  lg: 900,
  xl: 1200,
  xxl: 1640
};

var colors = {
  colorPrimary01: ColorPrimary01,
  colorPrimary02: ColorPrimary02,
  colorPrimary03: ColorPrimary03,
  colorBlack00: ColorBlack00,
  colorBlack05: ColorBlack05,
  colorBlack10: ColorBlack10,
  colorBlack20: ColorBlack20,
  colorBlack30: ColorBlack30,
  colorBlack40: ColorBlack40,
  colorBlack50: ColorBlack50,
  colorBlack60: ColorBlack60,
  colorBlack70: ColorBlack70,
  colorBlack80: ColorBlack80,
  colorBlack90: ColorBlack90,
  colorBlack100: ColorBlack100,
  colorTextHeadline: ColorTextHeadline,
  colorTextBody: ColorTextBody,
  colorTextInverted: ColorTextInverted,
  colorTextAlternate: ColorTextAlternate,
  colorTextLabel: ColorTextLabel,
  colorInteractionButton: ColorInteractionButton,
  colorInteractionButtonHover: ColorInteractionButtonHover,
  colorInteractionButtonFocus: ColorInteractionButtonFocus,
  colorInteractionTextLink: ColorInteractionTextLink,
  colorInteractionTextLinkHover: ColorInteractionTextLinkHover,
  colorInteractionTextLinkFocus: ColorInteractionTextLinkFocus,
  colorInteractionIcon: ColorInteractionIcon,
  colorInteractionIconHover: ColorInteractionIconHover,
  colorInteractionSelectedState: ColorInteractionSelectedState,
  colorInteractionFocusIndicator: ColorInteractionFocusIndicator,
  colorInteractionDeactivated: ColorInteractionDeactivated,
  colorFeedbackSuccess: ColorFeedbackSuccess,
  colorFeedbackError: ColorFeedbackError,
  colorFeedbackInformation: ColorFeedbackInformation,
  colorFeedbackWarning: ColorFeedbackWarning,
  colorFeedbackRating: ColorFeedbackRating,
  colorBackgroundSuccess: ColorBackgroundSuccess,
  colorBackgroundError: ColorBackgroundError,
  colorBackgroundInformation: ColorBackgroundInformation,
  colorBackgroundWarning: ColorBackgroundWarning,
  colorBackground01: ColorBackground01,
  colorBackground02: ColorBackground02,
  colorBackground03: ColorBackground03,
  colorBackground04: ColorBackground04,
  colorBackground05: ColorBackground05,
  colorBackground06: ColorBackground06,
  colorBackground07: ColorBackground07,
  colorBackgroundHero: ColorBackgroundHero,
  colorBackgroundBranded: ColorBackgroundBranded,
  colorBackgroundSite: ColorBackgroundSite,
  colorBorder01: ColorBorder01,
  colorBorder02: ColorBorder02,
  colorBorder03: ColorBorder03,
  colorBorder04: ColorBorder04
};

var BASE_FONT_SIZE = 16;

var FONT_FAMILY_MOONPIG = 'Moonpig, arial, sans-serif';
var FONT_WEIGHT_BOLD = 700;
var FONT_WEIGHT_LIGHT = 300;
var pxToRem = function pxToRem(size) {
  return "".concat(size / BASE_FONT_SIZE, "rem");
};
var TYPES = {
  legacyType100: [14, 24],
  legacyType200: [16, 24],
  legacyType300: [18, 24],
  legacyType400: [20, 28],
  legacyType500: [24, 32],
  legacyType600: [32, 40],
  legacyType700: [40, 48],
  legacyType800: [48, 56],
  legacyType900: [56, 64],
  legacyType1000: [64, 72]
};
var createType = function createType(type) {
  var _TYPES$type = _slicedToArray(TYPES[type], 2),
    fontSizePx = _TYPES$type[0],
    lineHeightPx = _TYPES$type[1];
  return {
    fontSize: pxToRem(fontSizePx),
    lineHeight: lineHeightPx / fontSizePx
  };
};
var typography = {
  // types
  legacyType100: createType('legacyType100'),
  legacyType200: createType('legacyType200'),
  legacyType300: createType('legacyType300'),
  legacyType400: createType('legacyType400'),
  legacyType500: createType('legacyType500'),
  legacyType600: createType('legacyType600'),
  legacyType700: createType('legacyType700'),
  legacyType800: createType('legacyType800'),
  legacyType900: createType('legacyType900'),
  legacyType1000: createType('legacyType1000'),
  // variants
  legacyBodySmall: {
    fontWeight: FONT_WEIGHT_LIGHT,
    fontFamily: FONT_FAMILY_MOONPIG,
    map: 'legacyType100'
  },
  legacyBodySmallBold: {
    fontWeight: FONT_WEIGHT_BOLD,
    fontFamily: FONT_FAMILY_MOONPIG,
    map: 'legacyType100'
  },
  legacyBody: {
    fontWeight: FONT_WEIGHT_LIGHT,
    fontFamily: FONT_FAMILY_MOONPIG,
    map: 'legacyType200'
  },
  legacyBodyBold: {
    fontWeight: FONT_WEIGHT_BOLD,
    fontFamily: FONT_FAMILY_MOONPIG,
    map: 'legacyType200'
  },
  legacyLinks: {
    fontWeight: FONT_WEIGHT_BOLD,
    fontFamily: FONT_FAMILY_MOONPIG,
    map: 'legacyType200'
  },
  legacyCtaButton: {
    fontWeight: FONT_WEIGHT_BOLD,
    fontFamily: FONT_FAMILY_MOONPIG,
    letterSpacing: '0.4px',
    map: 'legacyType200'
  },
  legacyDisplay1: {
    fontWeight: FONT_WEIGHT_BOLD,
    fontFamily: FONT_FAMILY_MOONPIG,
    map: {
      xs: 'legacyType200',
      md: 'legacyType300'
    }
  },
  legacyDisplay2: {
    fontWeight: FONT_WEIGHT_BOLD,
    fontFamily: FONT_FAMILY_MOONPIG,
    map: {
      xs: 'legacyType300',
      md: 'legacyType400'
    }
  },
  legacyDisplay3: {
    fontWeight: FONT_WEIGHT_BOLD,
    fontFamily: FONT_FAMILY_MOONPIG,
    map: {
      xs: 'legacyType400',
      md: 'legacyType500'
    }
  },
  legacyDisplay4: {
    fontWeight: FONT_WEIGHT_BOLD,
    fontFamily: FONT_FAMILY_MOONPIG,
    map: {
      xs: 'legacyType500',
      md: 'legacyType600'
    }
  },
  legacyDisplay5: {
    fontWeight: FONT_WEIGHT_BOLD,
    fontFamily: FONT_FAMILY_MOONPIG,
    map: 'legacyType600'
  },
  legacyDisplay6: {
    fontWeight: FONT_WEIGHT_BOLD,
    fontFamily: FONT_FAMILY_MOONPIG,
    map: 'legacyType700'
  },
  legacyDisplay7: {
    fontWeight: FONT_WEIGHT_BOLD,
    fontFamily: FONT_FAMILY_MOONPIG,
    map: 'legacyType800'
  },
  legacyDisplay8: {
    fontWeight: FONT_WEIGHT_BOLD,
    fontFamily: FONT_FAMILY_MOONPIG,
    map: 'legacyType900'
  },
  legacyDisplay9: {
    fontWeight: FONT_WEIGHT_BOLD,
    fontFamily: FONT_FAMILY_MOONPIG,
    map: 'legacyType1000'
  },
  // new tokens

  legacyTypeDisplay01: LegacyTypeDisplay01,
  legacyTypeDisplay02: LegacyTypeDisplay02,
  legacyTypeDisplay03: LegacyTypeDisplay03,
  legacyTypeDisplay04: LegacyTypeDisplay04,
  legacyTypeDisplay05: LegacyTypeDisplay05,
  legacyTypeBodyLead: LegacyTypeBodyLead,
  legacyTypeBodyText: LegacyTypeBodyText,
  legacyTypeBodyCaption: LegacyTypeBodyCaption,
  legacyTypeBodyLabel: LegacyTypeBodyLabel,
  legacyTypeButtonLabel: LegacyTypeButtonLabel,
  legacyTypeButtonUnderlined: LegacyTypeButtonUnderlined,
  legacyTypeButtonTextLink: LegacyTypeButtonTextLink,
  typeDisplay01: {
    xs: TypeMobileDisplay01,
    md: TypeDesktopDisplay01
  },
  typeDisplay02: {
    xs: TypeMobileDisplay02,
    md: TypeDesktopDisplay02
  },
  typeDisplay03: {
    xs: TypeMobileDisplay03,
    md: TypeDesktopDisplay03
  },
  typeDisplay04: {
    xs: TypeMobileDisplay04,
    md: TypeDesktopDisplay04
  },
  typeDisplay05: {
    xs: TypeMobileDisplay05,
    md: TypeDesktopDisplay05
  },
  typeDisplay06: {
    xs: TypeMobileDisplay06,
    md: TypeDesktopDisplay06
  },
  typeBodyLead: {
    xs: TypeMobileBodyLead,
    md: TypeDesktopBodyLead
  },
  typeBodyText: {
    xs: TypeMobileBodyText,
    md: TypeDesktopBodyText
  },
  typeBodyCaption: {
    xs: TypeMobileBodyCaption,
    md: TypeDesktopBodyCaption
  },
  typeBodyLabel: {
    xs: TypeMobileBodyLabel,
    md: TypeDesktopBodyLabel
  },
  typeButtonLabel: {
    xs: TypeMobileButtonLabel,
    md: TypeDesktopButtonLabel
  },
  typeButtonUnderlined: {
    xs: TypeMobileButtonUnderlined,
    md: TypeDesktopButtonUnderlined
  },
  typeButtonTextLink: {
    xs: TypeMobileButtonTextLink,
    md: TypeDesktopButtonTextLink
  }
};

var spacing = [SpacingNone, Spacing01, Spacing02, Spacing03, Spacing04, Spacing05, Spacing06, Spacing07, Spacing08, Spacing09, Spacing10, Spacing11, Spacing12, Spacing13, Spacing14, Spacing15, Spacing16];

var radii = [BorderRadius00, BorderRadius01, BorderRadius02, BorderRadius03, BorderRadius04, BorderRadius05, BorderRadius06, BorderRadiusCircle];

var shadows = [BoxShadow00, BoxShadow01, BoxShadow02, BoxShadow03, BoxShadow04, BoxShadow05];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var baseTheme = {
  baseFontSize: BASE_FONT_SIZE,
  spacing: spacing,
  shadows: shadows,
  breakpoints: {
    map: breakpointMap,
    keys: Object.keys(breakpointMap),
    up: function up(key) {
      return "@media (min-width: ".concat(breakpointMap[key] / BASE_FONT_SIZE, "em)");
    },
    down: function down(key) {
      return "@media (max-width: ".concat(breakpointMap[key] / BASE_FONT_SIZE - 0.01, "em)");
    }
  },
  radii: radii,
  siteWidth: 1200,
  richTextWidth: 600
};

// TO DELETE ONCE MOONPIG WEB USING @moonpig/launchpad-theme-moonpig
var theme = _objectSpread(_objectSpread({}, baseTheme), {}, {
  colors: colors,
  // Nb. @material-ui/system currently looks for 'palette' on theme
  // This may change in https://github.com/mui-org/material-ui/issues/13663
  // at which point we could drop this alias
  palette: colors,
  typography: typography
});

export { BASE_FONT_SIZE, baseTheme, colorValue, createType, spacing$1 as spacing, spacingPx, theme };
